import { PortalSidebar, type SidebarNavSection } from "@/shared/layout/PortalSidebar";
import { SidebarProfileCard } from "@/shared/layout/SidebarProfileCard";
import { usePatientAuthStore } from "@/stores/patientAuthStore";

interface CaregiverSidebarProps {
  name: string;
}

const navSections: SidebarNavSection[] = [
  {
    title: "Overview",
    items: [
      { path: "/caregiver", label: "My Patients", icon: "lucide:users", end: true },
      { path: "/caregiver/access-activity", label: "Access Activity", icon: "lucide:file-text" },
    ],
  },
  {
    title: "Account",
    items: [
      { path: "/caregiver/profile", label: "Profile Settings", icon: "lucide:credit-card" },
      // Same account, different lens — see PatientSidebar's matching link.
      { path: "/patient", label: "Back to My Records", icon: "lucide:arrow-left" },
    ],
  },
];

function getInitials(name: string): string {
  return name.split(" ").filter(Boolean).slice(0, 2).map((p) => p.charAt(0)).join("").toUpperCase();
}

export function CaregiverSidebar({ name }: CaregiverSidebarProps) {
  const signOut = usePatientAuthStore((s) => s.signOut);

  return (
    <PortalSidebar
      logoTitle="MedSyncIQ"
      logoSubtitle="Healthcare Platform"
      profileSlot={
        <SidebarProfileCard
          avatarInitials={getInitials(name)}
          name={name}
          detailsLine="Caregiver Account"
          showChevron
        />
      }
      navSections={navSections}
      onSignOut={() => signOut()}
    />
  );
}
